export const ROLE_ADMIN = 'administrateur'
export const ROLE_USER = 'utilisateur'
export const ROLE_DESACTIVE = 'desactive'
export const ROLE_ADMIN_VALUE = 2
export const ROLE_USER_VALUE = 1
export const ROLE_DESACTIVE_VALUE = 0

export const KEYCLOAK_ROLE_SUPERADMIN = 'iamanagement:superadmin'
